import { render, staticRenderFns } from "./addCourseDialog.vue?vue&type=template&id=56a7e3d6&scoped=true&"
import script from "./addCourseDialog.vue?vue&type=script&lang=js&"
export * from "./addCourseDialog.vue?vue&type=script&lang=js&"
import style0 from "./addCourseDialog.vue?vue&type=style&index=0&id=56a7e3d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a7e3d6",
  null
  
)

export default component.exports